"use client";

import { useEffect, useRef } from "react";
import { Result } from "@/types/result.types";

export interface VehicleResultsTableProps {
  results: Result[];
  costEntered: boolean;
  currency?: string;
  loading?: boolean;
  onLoaded?: () => void; // new prop
}

export default function VehicleResultsTable({ 
  results,
  costEntered,
  currency,
  loading = false, 
  onLoaded 
}: VehicleResultsTableProps) {
  const hasReportedLoaded = useRef(false);

  // Trigger onLoaded once data is actually populated
  useEffect(() => {
    if (!hasReportedLoaded.current && !loading && results) {
      onLoaded?.();
      hasReportedLoaded.current = true;
    }
  }, [results, loading, onLoaded]);

  return (
    <div className="results-section">
      <h2 className="results-title">Vehicle Calculations</h2>

        <table 
          className="vehicle-results-table"
          aria-label="Vehicle Calculations"
        >
          <thead>
            <tr>
              <th>ID</th>
              <th>Vehicle</th>
              <th>Fuel Used (L)</th>
              <th>CO₂ Emissions (kg)</th>
              {costEntered && <th>Fuel Cost ({currency})</th>}
            </tr>
          </thead>
          <tbody>
            {results.map((v, index) => {
              return (
                <tr key={v.id}>
                  <td>{index + 1}</td>
                  <td>{v.make} {v.model} ({v.modelYear})</td>
                  <td>{v.fuelUsedL.toFixed(2)}</td>
                  <td>{v.co2_kg.toFixed(2)}</td>
                  {costEntered && <td>{v.fuelCost.toFixed(2)}</td>}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
  );
}
